import React from "react";
import { Tooltip } from "antd";
import TSTable from "../../common/TSTable";
import { dateToHumanString, formatComma, toFixed } from "../../frameworks/Util";
import { TANK_STATUS_TH } from "../../constants/string";
import { URL_REPORT, URL_TANK } from "../../constants/urls";
import ReportButton from "../common/ReportButton";
import ErrorMessages from "../../common/ErrorMessages";

export default function ReportTankTransactionTable(props) {
  const { url } = props;
  const [errorMessages, setErrorMessages] = React.useState(null);

  const tableRef = React.useRef();

  const columns = [
    {
      title: 'พิมพ์',
      dataIndex: 'id',
      key: 'id',
      width: 70,
      render : (value, original) =>
        <center>
          <div style={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
            <ReportButton
              url={`${url}${value}/`} 
              tooltip={'พิมพ์รายงาน'}
              sentError={(e) => setErrorMessages(e)}
            />
          </div>
      </center>
    },
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created',
      key: 'created',
      width: 100,
      render : (value) => <center>{value ? dateToHumanString(value) : '-'}</center>
    },
    {
      title: 'แทงก์',
      dataIndex: 'tank_name',
      key: 'tank_name',
      searcher: true,
      render : (value) => value ? value : '-'
    },
    {
      title: 'Lot No.',
      dataIndex: 'lot_no',
      key: 'lot_no',
      searcher: true,
    },
    {
      title: 'เกรด',
      dataIndex: 'product_name',
      key: 'product_name',
      render : (value) => value ? value : '-'
    },
    {
      title: 'ความสูง (cm)',
      dataIndex: 'current_height',
      key: 'current_height',
      render : (value) => <center>{value ? value : '-'}</center>
    },
    {
      title: 'น้ำหนัก (Kgs)',
      dataIndex: 'current_weight',
      key: 'current_weight',
      render : (value) => <center>{value ? formatComma(value, 0) : '-'}</center>
    },
    {
      title: 'สถานะ',
      dataIndex: 'state', 
      key: 'state',
      render : (value) => value ? TANK_STATUS_TH[value] : '-'
    },
  ]


  return (
    <>
      <ErrorMessages message={errorMessages}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_TANK.TANK_TRANSACTION}
      />
    </>
  )
}